/* 關羽（字雲長） */
import { defineHero, U, P, S } from '../define.ts';

export default defineHero({
  id: 'guanyu', name: '關羽', sub: '字雲長', faction: 'shu', role: '戰士', weapon: 'guandao',
  look: {
    weaponName: '青龍偃月刀', skin: '#c4493a', hair: '#1c1818', beard: 'long', eye: 'narrow', head: 'hood', fx: '#72e3a3',
    c: { armor: '#3e7b50', sleeve: '#2f5e3f', cloth: '#2c573b', trim: '#d9b45c', pants: '#2a332c', boot: '#2b2420', cape: '#3f8a55', belt: '#6b3b24', metal: '#b9c1c8', hood: '#46935c', pole: '#2e4a3a', plume: '#c23b2e' },
  },
  skills: [
    ['X字斬', 'multi', '兩道分身交叉斬擊目標，造成 {75/125/175/225} 傷害並暈眩 1.75 秒。', { x: { k: 'nuke', dmg: [75, 125, 175, 225], cc: { stun: 1.75 }, fx: 'slam' }, aim: U(320), cd: 18, mp: [100, 110, 120, 120] }],
    ['五月雨斬', 'slam', '躍起後從高空劈下，範圍內最多 {200/250/300/350} 傷害，越靠近中心越痛。', { x: { dmg: [200, 250, 300, 350], r: 240, falloff: true }, aim: P(640, 240), cd: 15, mp: [95, 100, 105, 110] }],
    ['醉臥沙場', 'passive', '{7/10/13/16}% 機率閃避普攻；普攻有 {7/8/11/14}% 機率打出 {1.5/2/2.5/3} 倍傷害。', { pv: { evade: [7, 10, 13, 16], crit: { chance: [7, 8, 11, 14], mult: [1.5, 2, 2.5, 3] } } }],
    ['旋風斬', 'spin', '旋風環身 5 秒：魔法免疫，每秒對周圍敵人造成 {150/200/250} 傷害。', { x: { k: 'buff', dur: 5, immune: true, aoe: { dps: [150, 200, 250], r: 160 } }, aim: S(160), cd: 130, mp: [150, 180, 210] }],
  ],
});
